<template>
  <div>
    <ListLocations
      v-if="!component.locationsVariant || component.locationsVariant === 'list'"
      :component="component"
      :index="index"
    />
    <GridLocations v-else :component="component" :index="index" />
  </div>
</template>

<script lang="ts" setup>
  import type { GraphQLLocations } from '~/types/graphql';

  import ListLocations from './ListLocations.vue';
  import GridLocations from './GridLocations.vue';

  defineProps<{
    component: GraphQLLocations;
    index: number;
  }>();
</script>
